(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mexo-newsletter-form"] && !Shopify.designMode) return;
  try {
    function connectMexoNewsletter(form) {
  if (form.dataset.ready) return;
  form.dataset.ready = 'true';
  const status = form.querySelector('[data-newsletter-status]');
  if (status && (!window.location.hash || window.location.hash === '#' + form.id || window.location.hash === '#' + status.id)) status.focus();
}
document.querySelectorAll('.newsletter-form').forEach(connectMexoNewsletter);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.newsletter-form').forEach(connectMexoNewsletter));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mexo-reservation-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.querySelector('[data-reservation-config]');
  if (!config) return;
  const messages = JSON.parse(config.textContent);
  const key = 'mexo-reservation-bag-v1', pendingKey = 'mexo-reservation-pending-v1';
  let memory = [], storageFailed = false;
  const validID = id => /^\d{1,20}$/.test(String(id));
  const validQuantity = value => Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 99;
  function normalize(items) {
    const result = new Map();
    if (!Array.isArray(items)) return [];
    items.slice(0, 148).forEach(item => {
      if (item && validID(item.id) && validQuantity(item.quantity)) result.set(String(item.id), { id: String(item.id), quantity: Number(item.quantity) });
    });
    return [...result.values()];
  }
  function read() {
    if (storageFailed) return memory;
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (parsed.version !== 1 || parsed.expiresAt < Date.now()) return [];
      return normalize(parsed.items);
    } catch { storageFailed = true; return memory; }
  }
  function save(items) {
    memory = normalize(items);
    try { localStorage.setItem(key, JSON.stringify({ version: 1, expiresAt: Date.now() + 2592000000, items: memory })); return true; }
    catch { storageFailed = true; return false; }
  }
  function merge(items, id, quantity) {
    const found = items.find(item => item.id === String(id));
    if (found) found.quantity = Math.min(99, found.quantity + Number(quantity));
    else if (items.length < 148) items.push({ id: String(id), quantity: Number(quantity) });
    return items;
  }
  function counts(items = read() || []) {
    const total = items.reduce((sum, item) => sum + item.quantity, 0);
    document.querySelectorAll('[data-reservation-count]').forEach(node => { node.textContent = String(total); });
  }
  function products() {
    document.querySelectorAll('[data-reservation-product]').forEach(form => {
      if (form.dataset.reservationReady) return;
      form.dataset.reservationReady = 'true';
      const variant = form.querySelector('[name=reserve_variant]');
      variant.addEventListener('change', () => {
        const option = variant.querySelector('option:checked');
        const root = form.closest('[data-mexo-product]');
        if (option?.dataset.price && root) {
          root.querySelector('[data-product-price]').textContent = option.dataset.price;
          const compare = root.querySelector('[data-product-compare-price]');
          if (compare) compare.hidden = true;
        }
      });
      form.addEventListener('submit', event => {
        const quantity = form.querySelector('[name=reserve_quantity]').value;
        if (!validID(variant.value) || !validQuantity(quantity) || !form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
        if (save(merge(read() || [], variant.value, quantity))) {
          event.preventDefault();
          location.assign(form.action);
        }
        // Native GET navigation carries this selection if browser storage is unavailable.
      });
    });
  }
  function bag(root) {
    if (root.dataset.reservationReady) return;
    root.dataset.reservationReady = 'true';
    const catalogue = new Map();
    root.querySelectorAll('[data-reservation-catalogue]').forEach(node => {
      const product = JSON.parse(node.textContent);
      product.variants.forEach(variant => catalogue.set(String(variant.id), { ...variant, product }));
    });
    let items = read();
    if (items === null) items = normalize(JSON.parse(root.querySelector('[data-reservation-seed]').textContent));
    const initialLength = items.length;
    items = items.filter(item => catalogue.has(item.id));
    let stale = items.length !== initialLength;
    const address = new URL(location.href);
    const selected = address.searchParams.get('reserve_variant'), quantity = address.searchParams.get('reserve_quantity');
    if (selected) {
      if (catalogue.has(selected) && validQuantity(quantity)) items = merge(items, selected, quantity);
      else stale = true;
      address.searchParams.delete('reserve_variant'); address.searchParams.delete('reserve_quantity');
      history.replaceState({}, '', address);
    }
    const success = root.querySelector('[data-reservation-success]');
    if (success) {
      try {
        const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
        if (pending && Date.now() - pending.at < 86400000) {
          const submitted = normalize(pending.items);
          items = items.map(item => ({ ...item, quantity: item.quantity - (submitted.find(old => old.id === item.id)?.quantity || 0) })).filter(item => item.quantity > 0);
        }
        sessionStorage.removeItem(pendingKey);
      } catch { /* Never infer a submitted selection if browser storage is unavailable. */ }
      success.focus();
    }
    save(items);
    const form = root.querySelector('.reservation-contact-form');
    const summary = root.querySelector('[data-reservation-summary]');
    const submit = root.querySelector('[data-reservation-submit]');
    let sending = false;
    const lines = root.querySelector('[data-reservation-lines]');
    const warning = root.querySelector('[data-reservation-warning]');
    const create = (tag, className, text) => {
      const node = document.createElement(tag); node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    function draw(focusID) {
      lines.replaceChildren();
      const descriptions = [];
      items.forEach(item => {
        const variant = catalogue.get(item.id), product = variant.product;
        const title = product.title + (product.defaultVariant ? '' : ' · ' + variant.title);
        const row = create('article', 'reservation-line');
        const art = root.querySelector('[data-reservation-art="' + product.id + '"]');
        if (art) {
          const fragment = art.content.cloneNode(true);
          // The same product can occur in several sizes; SVG clipping IDs must stay unique.
          fragment.querySelectorAll('[id]').forEach(node => {
            const oldID = node.id, newID = oldID + '-reserve-' + item.id;
            fragment.querySelectorAll('[clip-path]').forEach(clip => { if (clip.getAttribute('clip-path') === 'url(#' + oldID + ')') clip.setAttribute('clip-path', 'url(#' + newID + ')'); });
            node.id = newID;
          });
          row.append(fragment);
        }
        const detail = create('div', 'reservation-line-detail'), heading = create('h3', '');
        const link = create('a', '', title); link.href = product.url; heading.append(link);
        detail.append(heading, create('p', 'meta', messages.price + ': ' + variant.price));
        const controls = create('div', 'reservation-controls');
        const label = create('label', 'meta', messages.quantity), input = create('input', '');
        input.id = 'reservation-quantity-' + item.id; input.type = 'number'; input.min = '1'; input.max = '99'; input.step = '1'; input.inputMode = 'numeric'; input.value = String(item.quantity);
        label.htmlFor = input.id; input.setAttribute('aria-label', messages.quantity + ': ' + title);
        input.addEventListener('change', () => {
          if (!validQuantity(input.value)) { input.value = String(item.quantity); return; }
          items = (read() || items).filter(entry => catalogue.has(entry.id));
          const current = items.find(entry => entry.id === item.id);
          if (current) current.quantity = Number(input.value);
          save(items); draw(input.id);
        });
        const remove = create('button', 'reservation-remove', messages.remove);
        remove.type = 'button'; remove.setAttribute('aria-label', messages.remove + ': ' + title);
        remove.addEventListener('click', () => {
          items = (read() || items).filter(entry => entry.id !== item.id && catalogue.has(entry.id));
          save(items); draw();
          (lines.querySelector('input') || root.querySelector('[data-reservation-empty]')).focus();
        });
        controls.append(label, input, remove); detail.append(controls); row.append(detail); lines.append(row);
        descriptions.push(title + '\n' + messages.quantity + ': ' + item.quantity + ' | ' + messages.price + ': ' + variant.price + '\n' + product.url + '?variant=' + item.id);
      });
      const empty = root.querySelector('[data-reservation-empty]'); empty.hidden = items.length > 0; empty.tabIndex = -1;
      if (summary) { summary.readOnly = true; summary.value = items.length ? messages.request + '\n\n' + descriptions.join('\n\n') + '\n\n' + messages.terms : ''; }
      if (submit) { submit.disabled = !items.length; const label = submit.querySelector('[data-reservation-submit-label]'); if (label) label.textContent = messages.submit; }
      warning.hidden = !storageFailed && !stale;
      warning.textContent = storageFailed ? messages.storage : stale ? messages.updated : '';
      counts(items);
      if (focusID) document.getElementById(focusID)?.focus();
    }
    draw();
    root.querySelector('[data-reservation-errors]')?.focus();
    if (summary) form.addEventListener('submit', event => {
      if (sending) { event.preventDefault(); return; }
      // Re-read cross-tab changes before producing the authoritative request summary.
      items = (read() || items).filter(item => catalogue.has(item.id));
      draw();
      if (!items.length || !form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      root.querySelector('[data-reservation-reference]').value = 'MX-R-' + crypto.randomUUID();
      try { sessionStorage.setItem(pendingKey, JSON.stringify({ at: Date.now(), items })); } catch { /* Form remains usable without storage. */ }
      sending = true;
      submit.disabled = true; submit.textContent = messages.sending;
      // Shopify handles validation, spam protection and the real success response.
    });
    window.addEventListener('storage', event => {
      if (event.key === key || event.key === null) { items = (read() || []).filter(item => catalogue.has(item.id)); draw(); }
    });
    window.addEventListener('pageshow', () => { sending = false; items = (read() || items).filter(item => catalogue.has(item.id)); draw(); });
  }
  function init() { products(); document.querySelectorAll('[data-reservation-bag]').forEach(bag); counts(); }
  init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) counts(); });
  window.addEventListener('pageshow', () => counts());
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mexo-trademark"] && !Shopify.designMode) return;
  try {
    (() => {
  const excluded = 'script,style,noscript,textarea,input,select,option,code,pre,kbd,svg,math,[contenteditable]:not([contenteditable="false"]),.mexo-trademark,.brand--registered';
  function references(text) {
    const result = [];
    for (const match of text.matchAll(/\b(mexo)([®™]?)/giu)) {
      const start = match.index, end = start + match[0].length;
      if (/[\p{L}\p{N}_]/u.test(text[start - 1] || '') || /[\p{L}\p{N}_]/u.test(text[end] || '')) continue;
      const token = text.slice(0, start).split(/\s/).at(-1) + text.slice(start).split(/\s/)[0];
      if (/[\/@]|[a-z]+:\/\/|mailto:|www\.|mexo\.[a-z]{2,}/i.test(token)) continue;
      result.push({start, end, label:match[1]});
    }
    return result;
  }
  function decorate(node) {
    if (!node.parentElement || node.parentElement.closest(excluded)) return;
    const text = node.nodeValue, matches = references(text).filter(match => !(match.end === text.trimEnd().length && node.nextSibling?.nodeType === 1 && node.nextSibling.tagName === 'SUP' && /^[®™]$/.test(node.nextSibling.textContent)));
    if (!matches.length) return;
    const fragment = document.createDocumentFragment(); let previous = 0;
    matches.forEach(match => {
      fragment.append(document.createTextNode(text.slice(previous, match.start)));
      const brand = document.createElement('span'); brand.className = 'mexo-trademark';
      brand.append(document.createTextNode(match.label));
      const mark = document.createElement('sup'); mark.textContent = '®'; brand.append(mark);
      fragment.append(brand); previous = match.end;
    });
    fragment.append(document.createTextNode(text.slice(previous)));
    // Preserve the original text run as one flex/grid item (for buttons and labels).
    if (node.parentElement.classList.contains('mexo-trademark-copy')) {
      node.replaceWith(fragment);
    } else {
      const copy = document.createElement('span'); copy.className = 'mexo-trademark-copy';
      copy.append(fragment); node.replaceWith(copy);
    }
  }
  function scan(root) {
    if (root.nodeType === 3) { decorate(root); return; }
    if (root.nodeType !== 1 || root.closest(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(decorate);
  }
  scan(document.body);
  const title = document.title, titleMatches = references(title);
  if (titleMatches.length) {
    let updated = title;
    [...titleMatches].reverse().forEach(match => { updated = updated.slice(0,match.start) + match.label + '®' + updated.slice(match.end); });
    document.title = updated;
  }
  const observer = new MutationObserver(records => {
    const roots = new Set();
    records.forEach(record => { if (record.type === 'characterData') roots.add(record.target); else record.addedNodes.forEach(node => roots.add(node)); });
    roots.forEach(node => { if (node.isConnected) scan(node); });
  });
  observer.observe(document.body, {subtree:true,childList:true,characterData:true});
})();
  } catch(e) { console.error(e); }
})();

})();
